<template>
  <el-drawer
    v-model="self.isShow"
    v-bind="$attrs"
    :close-on-press-escape="false"
    :close-on-click-modal="false"
    :with-header="false">
    <div class="column h100">
      <div
        v-if="showHeader"
        class="row font-333 mb20">
        <div class="flex-1 drawer-title">{{ self.title || "self中传标题title" }}</div>
        <el-icon
           class="font-pointer pcfs20"
          @click="close">
          <Close />
        </el-icon>
      </div>
      <div v-else-if="showCloseBtn">
        <div class="row">
          <div class="flex-1"></div>
          <el-icon
            class="font-pointer pcfs20 pcmr10"
            @click="close">
            <Close />
          </el-icon>
        </div>
      </div>
      <slot></slot>
    </div>
  </el-drawer>
</template>

<script>
export default {
  name: "scrm-drawer",
  inheritAttrs: true,
  props: {
    self: {
      type: Object,
    },
    showHeader: {
      type: Boolean,
      default: true,
    },
    showCloseBtn:{
      type: Boolean,
      default: true,
    }
  },
  data() {
    return {};
  },
  computed: {},
  mounted() {},
  methods: {
    close() {
      const that = this;
      that.$emit("close");
    },
  },
};
</script>

<style scoped lang="scss">

.drawer-title {
  font-size: 16px;
  text-align: left;
}
</style>
